var bbT = window.bbT || (window.bbT = function(k,d){var o=window.BB_T;return o&&o[k]!=null?o[k]:d;});
/* BoxenBaas — SparkLayer B2B brug voor de VARIANTTABEL (kopie-theme).
   De prijskaart/staffel/calculator worden al B2B-bewust gerenderd door de
   theme (bb-product-main.liquid). Dit script doet alleen de varianttabel
   (bb-vpt), die zichzelf via innerHTML herbouwt -> daarom een MutationObserver
   die de afgesproken B2B-prijs per variant terugzet na elke re-render.
   Retail blijft staan voor varianten zonder afspraak; niet-B2B: niets.

   Daarnaast: zet het PO-nummer-veld in de B2B-checkout. SparkLayer leest
   spark.options.checkoutCustomElements (backend-default = leeg []); we voegen
   ons PO-veld idempotent + zelfherstellend toe zodra spark beschikbaar is. */
(function () {
  'use strict';

  // SparkLayer PDP-widget is nu zichtbaar (hide verwijderd door SparkLayer-installatie).

  // --- Winkelwagen-lade (SparkLayer "Mijn bestelling", spark-drawer) — optie A "Regels" ---
  // 23-09-2026, DESIGN.md §4 rij "Winkelwagen-lade". Vervangt de juni-CSS (LA_CSS), die
  // élke <header> een tint gaf — ook de naam-header van iedere productregel.
  // Werking blijft van SparkLayer. Wij: (1) één adoptedStyleSheet op de drawer-shadowRoot,
  // (2) data-bb-markeringen die we structureel vinden (tags/rollen/hun svg-*-elementen,
  // geen Tailwind-atomen), (3) tekstknopen Solid-veilig bijwerken (.data zetten, nooit
  // vervangen; eigen knoop alleen ACHTER hun tekstknoop, want Solid schrijft firstChild).
  // De lade bestaat alleen zolang hij open is (SparkLayer maakt spark-drawer per open aan
  // op <body>, met attribuut initial-tab="cart|account").
  // ⚠️ Broos bij SparkLayer-updates (4.5.10 op 23-09): na elke update de lade nakijken.
  var LADE_CSS = [
    ':host{--spark-input-color:#7a8ea8;--spark-button-large-color:#2f6fd0}',
    // focus-ring: base.css zet outline 0; hier expliciet 2 px blauw op alles wat focus krijgt
    '[data-bb=paneel] button:focus-visible,[data-bb=paneel] a:focus-visible,[data-bb=paneel] input:focus-visible,[data-bb=paneel] [role=button]:focus-visible{outline:2px solid #4781d7!important;outline-offset:2px!important}',
    '[data-bb=paneel] input:focus-visible{outline-offset:0!important}',
    ':host>div[role=button]:focus-visible{outline:2px solid #4781d7!important;outline-offset:-2px!important}',
    // hun transition-all liet ook de focus-ring 150 ms in-animeren (3px currentColor → 2px blauw)
    '[data-bb=paneel] button,[data-bb=paneel] a,[data-bb=paneel] input{transition-property:background-color,border-color,color,opacity!important}',
    // stepper heeft overflow:hidden → ring binnen de knop, anders wordt hij afgeknipt
    '[data-bb=paneel] [data-bb=stepper]>button:focus-visible,[data-bb=paneel] [data-bb=stepper]>input:focus-visible{outline-offset:-2px!important}',
    '[data-bb=paneel] main>div:has(>ul){overscroll-behavior:contain}',
    '@media (max-width:699px){[data-bb=paneel]{max-width:100%!important}}',
    // kopbalk 64, wit, lijn eronder
    '[data-bb=kop]{height:64px;min-height:64px;box-sizing:border-box;align-items:center;background:#fff!important;border-bottom:1px solid #e7eef8;padding:0 12px 0 0}',
    '[data-bb=kop]>nav{align-self:stretch;align-items:center}',
    '[data-bb=tab-bestelling]{pointer-events:none;cursor:default;margin:0;padding:0 0 0 24px!important;background:transparent!important;box-shadow:none!important;opacity:1!important;gap:0;font:700 22px/1.2 Assistant,sans-serif!important;color:#0f172a!important;white-space:nowrap}',
    '[data-bb=tab-bestelling]>span{display:inline!important}',
    '[data-bb=tab-bestelling]>svg-tab-order{display:none!important}',
    '[data-bb=tab-bestelling]::after{content:attr(data-bb-count);margin-left:10px;font:400 14px/1.2 Assistant,sans-serif;color:#516071}',
    '[data-bb=tab-account]{display:none!important}',
    '[data-bb=kop]>div{align-items:center;gap:4px}',
    '[data-bb=avatar]{display:flex!important;align-items:center;gap:8px;height:44px!important;padding:0 10px!important;border-radius:8px;background:transparent;cursor:pointer;color:#2f6fd0;font:700 14px/1 Assistant,sans-serif;transition:background-color .12s}',
    '[data-bb=avatar]:hover{background:#f5f8fc}',
    '[data-bb=avatar]::after{content:"Mijn account"}',
    '[data-bb=avatar]>div{width:28px!important;height:28px!important;min-width:28px;background:#2f6fd0!important}',
    '[data-bb=avatar] em{width:auto!important;font:700 12px/1 Assistant,sans-serif!important;font-style:normal!important}',
    '[data-bb=avatar]>svg-chevron-down,[data-bb=avatar]+div{display:none!important}',
    '[data-bb=sluit]{width:44px!important;height:44px!important;padding:0!important;display:grid!important;place-items:center;border-radius:8px;color:#516071}',
    '[data-bb=sluit]:hover{background:#f5f8fc}',
    '[data-bb=kop-dubbel]{display:none!important}',
    // binnenmarge 24 (mockup) i.p.v. hun sm:56; lijst en totaalblok lopen tot de rand
    '[data-bb=inhoud]{padding:16px 24px 0!important}',
    '[data-bb=inhoud] main>div:has(>ul){margin-left:-24px!important;margin-right:-24px!important;padding-left:24px!important;padding-right:24px!important}',
    // zoekveld + secundaire knop
    '[data-bb=zoek]{height:44px!important;box-sizing:border-box;border:1px solid #7a8ea8!important;border-radius:6px!important;background:#fff!important;font:400 14px Assistant,sans-serif!important;color:#0f172a}',
    '[data-bb=zoek]::placeholder{color:#7a8ea8;opacity:1}',
    '[data-bb=acties]{margin-left:8px;height:44px!important;box-sizing:border-box;padding:0 14px!important;border:1px solid #4781d7!important;border-radius:8px!important;background:#fff!important;color:#2f6fd0!important;font:700 14px/1 Assistant,sans-serif!important}',
    '[data-bb=acties]:hover{background:#f5f8fc!important}',
    // productregel = prijslijst-rij
    '[data-bb=regel]{padding:16px 0!important;row-gap:8px!important}',
    '[data-bb=regel]>div:first-child{column-gap:16px!important}',
    '[data-bb=foto]{width:64px!important;height:64px!important;min-width:64px;flex:0 0 64px;box-sizing:border-box;border:1px solid #e7eef8;border-radius:4px!important;background-color:#fff!important;background-size:contain!important;background-repeat:no-repeat!important;background-position:center!important;overflow:hidden}',
    '[data-bb=foto] img{width:100%;height:100%;object-fit:contain}',
    '[data-bb=regel] header{background:none!important;border:0!important}',
    '[data-bb=foto]+div{min-width:0}',
    '[data-bb=naam],[data-bb=naam] *{font:700 14px/1.3 Assistant,sans-serif!important;color:#0f172a!important;letter-spacing:0!important;overflow-wrap:anywhere}',
    '[data-bb=meta]{display:block!important;margin-top:2px;font:400 13px/1.4 "SF Mono",Menlo,monospace!important;color:#516071!important}',
    '[data-bb=meta] .bb-maat{font-family:Assistant,sans-serif}',
    '[data-bb=meta-mobiel]{display:none!important}',
    '[data-bb=regel] div:has(>[data-bb=stepper]){margin-top:10px!important;gap:8px!important}',
    '[data-bb=stepper]{height:40px!important;box-sizing:border-box;width:136px!important;min-width:136px!important;border:1px solid #7a8ea8!important;border-radius:6px!important;overflow:hidden;background:#fff}',
    '[data-bb=stepper]>button{width:40px!important;min-width:40px!important;height:100%;color:#0f172a;touch-action:manipulation}',
    '[data-bb=stepper]>button:hover{background:#f5f8fc}',
    '[data-bb=stepper]>input{height:100%;box-sizing:border-box;border-color:#e7eef8!important;font:700 14px/1 "SF Mono",Menlo,monospace!important;color:#0f172a!important;text-align:center}',
    '[data-bb=prullenbak]{width:40px;height:40px;display:grid;place-items:center;border-radius:6px;color:#516071!important;opacity:1!important}',
    '[data-bb=prullenbak]:hover{background:#f5f8fc;color:#0f172a!important}',
    '[data-bb=prullenbak] *{width:20px!important;height:20px!important}',
    '[data-bb=doos]{margin-top:4px;font:400 12px/1.4 Assistant,sans-serif!important;color:#516071!important}',
    '[data-bb=doos][data-bb-doos] svg-info{display:none!important}',
    '[data-bb=regeltotaal]{font:700 16px/1.2 Assistant,sans-serif!important;color:#0f172a!important;font-variant-numeric:tabular-nums;white-space:nowrap}',
    '[data-bb=eenheid],[data-bb=eenheid] *{font:400 13px/1.3 Assistant,sans-serif!important;color:#516071!important;white-space:nowrap}',
    '[data-bb=staffel]{margin-top:4px;padding:2px 6px!important;border-radius:4px;background:#f0f9f4!important;color:#2f7d55!important}',
    '[data-bb=staffel],[data-bb=staffel] *{font:700 12px/1.3 Assistant,sans-serif!important;color:#2f7d55!important}',
    '[data-bb=staffel]>svg-tier-pricing{display:none!important}',
    '[data-bb=staffel]:hover span{text-decoration:underline}',
    // totaalblok
    '[data-bb=som]{display:flex!important;flex-direction:column;background:#f5f8fc!important;border-top:1px solid #e7eef8;margin-left:-24px!important;margin-right:-24px!important;padding:16px 24px 20px!important}',
    '[data-bb=som]>*{margin:0!important}',
    '[data-bb=som-rij]{align-items:baseline!important;font:400 14px/1.3 Assistant,sans-serif!important}',
    '[data-bb=som-label],[data-bb=som-label] *{display:inline!important;font:400 14px/1.3 Assistant,sans-serif!important;color:#516071!important}',
    '[data-bb=som-bedrag]{font:700 22px/1.2 Assistant,sans-serif!important;color:#0f172a!important;font-variant-numeric:tabular-nums}',
    '[data-bb=fijn]{order:1;display:block!important;margin-top:2px!important;padding:0!important;text-align:left!important;font:400 13px/1.4 Assistant,sans-serif!important;color:#516071!important}',
    '[data-bb=som]>div:has([data-bb=afrekenen]){order:2;margin-top:14px!important}',
    '[data-bb=som]>.bb-verzend{order:1;display:flex;justify-content:space-between;align-items:baseline;margin-top:6px!important;font:400 14px/1.3 Assistant,sans-serif;color:#516071}',
    '[data-bb=som]>.bb-verzend>span:last-child{font-weight:700;color:#0f172a;font-variant-numeric:tabular-nums}',
    '[data-bb=afrekenen]{width:100%;height:44px!important;min-height:44px;box-sizing:border-box;padding:0 16px!important;border:0!important;border-radius:8px!important;background:#2f6fd0!important;color:#fff!important;font:700 16px/1 Assistant,sans-serif!important;transition:background-color .12s}',
    '[data-bb=afrekenen] *{color:#fff!important;font:inherit!important}',
    '[data-bb=afrekenen]:hover{background:#2559b8!important}',
    // minimumorder (20-10): regel boven de knop, knop uit tot het minimum gehaald is
    '[data-bb=som]>.bb-minimum{order:1;display:block;margin-top:10px!important;font:400 14px/1.4 Assistant,sans-serif;color:#0f172a}',
    '[data-bb=som]>.bb-minimum>b{font-weight:700;font-variant-numeric:tabular-nums;white-space:nowrap}',
    // uit-stand als vaste lichte kleur (= #2f6fd0 op 45 %), geen opacity: de focusring blijft vol zichtbaar
    '[data-bb=afrekenen][aria-disabled=true],[data-bb=afrekenen][aria-disabled=true]:hover{background:#9dbbe8!important;cursor:not-allowed}',
    '[data-bb=afrekenen]:focus-visible{outline:2px solid #2f6fd0!important;outline-offset:2px}',
    '@media (prefers-reduced-motion:reduce){[data-bb=avatar],[data-bb=afrekenen]{transition:none}}'
  ].join('\n');
  var _ladeSheet = null;
  function ladeSheet() {
    if (_ladeSheet === null) {
      try { _ladeSheet = new CSSStyleSheet(); _ladeSheet.replaceSync(LADE_CSS); }
      catch (e) { _ladeSheet = false; } // oude browser: <style>-fallback hieronder
    }
    return _ladeSheet;
  }
  function ensureLadeStyle(sr) {
    var sh = ladeSheet();
    if (sh) {
      if (sr.adoptedStyleSheets.indexOf(sh) === -1) sr.adoptedStyleSheets = sr.adoptedStyleSheets.concat([sh]);
    } else if (!sr.getElementById('bb-lade-style')) {
      var s = document.createElement('style'); s.id = 'bb-lade-style'; s.textContent = LADE_CSS; sr.appendChild(s);
    }
  }
  function mark(el, v) { if (el && el.getAttribute('data-bb') !== v) el.setAttribute('data-bb', v); return el; }
  var VERZEND_DREMPEL = 250, VERZEND_KOSTEN = '€ 12,95'; // = Shopify General profile NL+BE (23-09)
  // Minimumorder (Stef 20-10): € 150 excl. btw aan artikelen; verzendkosten tellen niet mee,
  // geen uitzonderingen per klant. Harde grens staat in SparkLayer (Order total limits, Base group).
  var MIN_ORDER = 150;
  function setData(node, v) { if (node && node.nodeType === 3 && node.data !== v) node.data = v; }
  function firstText(el) {
    if (!el) return null;
    for (var n = el.firstChild; n; n = n.nextSibling) if (n.nodeType === 3 && n.data.trim()) return n;
    return null;
  }
  function nl(n) { return Number(n).toLocaleString('nl-NL'); }
  // "Artikelcode: BRI-013 | Afmetingen: 18 x 12 x 2.5 cm" → sku + "18 × 12 × 2,5 cm"
  function parseMeta(s) {
    var sku = null, rest = [];
    String(s).split(' | ').forEach(function (part) {
      var m = part.match(/^\s*Artikelcode:\s*(\S+)\s*$/);
      if (m) { sku = m[1]; return; }
      var v = part.replace(/^[^:]{1,30}:\s*/, '').trim();
      if (v) rest.push(v.replace(/(\d)\.(\d)/g, '$1,$2').replace(/\s+x\s+/g, ' × '));
    });
    return sku ? { sku: sku, rest: rest.join(' · ') } : null;
  }
  function cartItems() {
    try { var c = spark().getCartCache(); return (c && c.items) || []; } catch (e) { return []; }
  }
  function packSizeOf(item) {
    var s = ((item && item.settings) || []).filter(function (x) { return x && x.key === 'packSize'; })[0];
    var n = s ? Number(s.value) : 0;
    return n > 0 ? n : 0;
  }
  // "13 dozen van 50" — alleen bij een zekere verpakkingseenheid, anders null (= hun tekst laten).
  // Zeker = SparkLayer-packSize > 1 (de PDP-stap = VE voor stuks-geprijsde SKU's; per-doos
  // SKU's hebben stap 1) én het aantal is een veelvoud én de Hub spreekt het niet tegen
  // (afspraak per doos, of een andere pack_size in de afspraak). Hub-data onbekend = niets.
  function doosTekst(sku, qty, ps) {
    if (!_hubVe) return null;
    var h = _hubVe[sku];
    if (h && (h.perDoos || (h.ps > 0 && h.ps !== ps))) return null;
    if (!(ps > 1) || !(qty > 0) || qty % ps !== 0) return null;
    var n = qty / ps;
    return n + (n === 1 ? bbT('bb.js_bb_sparklayer_b2b.doos', ' doos') : bbT('bb.js_bb_sparklayer_b2b.dozen', ' dozen')) + bbT('bb.js_bb_besteltafel.van', ' van ') + ps;
  }

  var _ladeRedirecting = false;
  function naarPortaal() {
    try { spark().closeDrawer(); } catch (e) {}
    if (location.pathname.replace(/\/$/, '') !== (window.BB_LP||'') + '/pages/mijn-account') location.assign((window.BB_LP||'') + '/pages/mijn-account');
  }

  function applyLade(host) {
    var sr = host.shadowRoot;
    if (!sr) return;
    ensureLadeStyle(sr);
    // Account-modus bestaat niet meer: ons portaal is /pages/mijn-account.
    if (host.getAttribute('initial-tab') === 'account') {
      if (!_ladeRedirecting) { _ladeRedirecting = true; naarPortaal(); }
      return;
    }
    var panel = null;
    for (var i = 0; i < sr.children.length; i++) {
      var c = sr.children[i];
      if (c.tagName === 'DIV' && c.querySelector(':scope > header > nav')) { panel = c; break; }
    }
    if (!panel) return;
    mark(panel, 'paneel');
    var kop = mark(panel.querySelector(':scope > header'), 'kop');
    var items = cartItems();
    Array.prototype.forEach.call(kop.querySelectorAll(':scope > nav > button'), function (b) {
      if (b.querySelector('svg-tab-account')) { mark(b, 'tab-account'); return; }
      if (b.querySelector('svg-tab-order')) {
        mark(b, 'tab-bestelling');
        b.setAttribute('tabindex', '-1');
        var cnt = items.length ? (items.length === 1 ? bbT('bb.js_bb_sparklayer_b2b.1_regel', '1 regel') : items.length + bbT('bb.js_bb_sparklayer_b2b.regels', ' regels')) : '';
        if (b.getAttribute('data-bb-count') !== cnt) b.setAttribute('data-bb-count', cnt);
      }
    });
    var rechts = kop.lastElementChild;
    if (rechts && rechts.tagName !== 'NAV') {
      Array.prototype.forEach.call(rechts.querySelectorAll('button'), function (b) {
        if (b.querySelector('svg-arrow-right') || b.querySelector('svg-close')) { mark(b, 'sluit'); return; }
        if (b.querySelector('em') && b.querySelector('svg-chevron-down') && !b.closest('[data-bb=avatar]+div')) {
          mark(b, 'avatar');
          if (b.getAttribute('aria-label') !== 'Mijn account') b.setAttribute('aria-label', bbT('bb.js_bb_sparklayer_b2b.mijn_account', 'Mijn account'));
          b.removeAttribute('aria-expanded');
        }
      });
    }
    var main = panel.querySelector('main');
    if (main) {
      var inh = main.parentElement;
      if (inh && inh.parentElement === panel) mark(inh, 'inhoud');
    }
    if (!main || !main.querySelector('search')) return; // alleen de bestellijst-weergave (niet de checkoutstappen)
    Array.prototype.forEach.call(main.querySelectorAll('header'), function (h) {
      if (h.querySelector('h1') && h.querySelector('svg-expand')) mark(h, 'kop-dubbel');
    });
    mark(main.querySelector('search input[type=text]'), 'zoek');
    mark(main.querySelector('search button'), 'acties');

    // productregels
    Array.prototype.forEach.call(main.querySelectorAll('ul > div'), function (row) {
      var qtyIn = row.querySelector('input[type=number]');
      var foto = row.querySelector('a[href]');
      if (!qtyIn || !foto) return;
      mark(row, 'regel');
      mark(foto, 'foto');
      var grow = foto.nextElementSibling, right = grow && grow.nextElementSibling;
      if (!grow) return;
      mark(grow.querySelector(':scope > header h4'), 'naam');
      var ps = grow.querySelectorAll(':scope > p');
      var meta = ps[0], sku = null;
      if (ps[1]) mark(ps[1], 'meta-mobiel');
      if (meta) {
        var tn = firstText(meta), extra = meta.querySelector('.bb-maat');
        var fresh = tn && /Artikelcode:/.test(tn.data);
        if (fresh) meta.setAttribute('data-bb-src', tn.data);
        var parsed = parseMeta(meta.getAttribute('data-bb-src') || '');
        if (parsed && tn) {
          mark(meta, 'meta');
          if (meta.getAttribute('translate') !== 'no') meta.setAttribute('translate', 'no');
          sku = parsed.sku;
          setData(tn, parsed.sku);
          if (parsed.rest) {
            if (!extra) { extra = document.createElement('span'); extra.className = 'bb-maat'; meta.appendChild(extra); }
            if (extra.textContent !== ' · ' + parsed.rest) extra.textContent = ' · ' + parsed.rest;
          } else if (extra) { extra.remove(); }
        }
      }
      var stepper = mark(qtyIn.parentElement, 'stepper');
      var trash = stepper.nextElementSibling;
      if (trash && trash.tagName === 'BUTTON') {
        mark(trash, 'prullenbak');
        if (!trash.getAttribute('aria-label')) trash.setAttribute('aria-label', bbT('bb.js_bb_sparklayer_b2b.verwijderen', 'Verwijderen'));
      }
      var doos = null;
      Array.prototype.forEach.call(grow.querySelectorAll('[role=button]'), function (d) { if (d.querySelector('svg-info')) doos = d; });
      if (doos) {
        mark(doos, 'doos');
        var dn = firstText(doos);
        if (dn && !doos.hasAttribute('data-bb-src')) doos.setAttribute('data-bb-src', dn.data);
        var item = null;
        for (var k = 0; k < items.length; k++) if (items[k].sku === sku) { item = items[k]; break; }
        var txt = (sku && item) ? doosTekst(sku, Number(qtyIn.value), packSizeOf(item)) : null;
        if (dn) setData(dn, txt || doos.getAttribute('data-bb-src'));
        if (txt) doos.setAttribute('data-bb-doos', '1'); else doos.removeAttribute('data-bb-doos');
      }
      if (right) {
        mark(right.querySelector(':scope > header h4'), 'regeltotaal');
        mark(right.querySelector('p'), 'eenheid');
        var st = null;
        Array.prototype.forEach.call(right.querySelectorAll('button'), function (b) { if (b.querySelector('svg-tier-pricing')) st = b; });
        if (st) {
          mark(st, 'staffel');
          var sp = st.querySelector('span');
          setData(firstText(sp), bbT('bb.js_bb_sparklayer_b2b.staffelkorting', 'Staffelkorting'));
        }
      }
    });

    // totaalblok: van "Subtotaal" omhoog tot het blok dat ook de afrekenknop bevat
    var strongs = main.querySelectorAll('strong');
    if (strongs.length >= 2) {
      var label = strongs[0], bedrag = strongs[strongs.length - 1];
      var som = label.parentElement;
      while (som && som !== main && !som.querySelector('button')) som = som.parentElement;
      if (som && som !== main) {
        mark(som, 'som');
        mark(label.parentElement && label.parentElement.parentElement, 'som-rij');
        mark(label.parentElement, 'som-label');
        mark(bedrag, 'som-bedrag');
        setData(firstText(label), bbT('bb.js_bb_sparklayer_b2b.subtotaal_excl_btw', 'Subtotaal excl. btw'));
        var cntSpan = label.nextElementSibling;
        if (cntSpan) {
          var tns = [];
          for (var n = cntSpan.firstChild; n; n = n.nextSibling) if (n.nodeType === 3) tns.push(n);
          var stuks = null;
          tns.forEach(function (t) { var m = t.data.match(/^\s*([\d.]+)\s*stuks?\s*$/); if (m) stuks = t; });
          if (stuks) {
            var num = Number(stuks.data.replace(/[^\d]/g, ''));
            tns.forEach(function (t) {
              if (t === stuks) setData(t, nl(num) + bbT('bb.js_bb_sparklayer_b2b.stuks', ' stuks'));
              else if (/^\s*\(\s*$/.test(t.data) || t.data === ' · ') setData(t, ' · ');
              else setData(t, '');
            });
          }
        }
        var btn = som.querySelector('button');
        mark(btn, 'afrekenen');
        var fijn = mark(som.querySelector(':scope > p'), 'fijn');
        // Verzendkosten (23-09, Stef): Shopify rekent € 12,95 onder € 250 excl. btw
        // (taxesIncluded=false → drempel op het subtotaal excl.), vanaf € 250 gratis → dan geen regel.
        var sub = Number((bedrag.textContent || '').replace(/[^\d,]/g, '').replace(',', '.'));
        var vz = som.querySelector(':scope > .bb-verzend');
        if (sub > 0 && sub < VERZEND_DREMPEL) {
          if (!vz) {
            vz = document.createElement('div');
            vz.className = 'bb-verzend';
            vz.innerHTML = bbT('bb.js_bb_sparklayer_b2b.verzendkosten', '<span>Verzendkosten</span><span></span>');
            som.insertBefore(vz, fijn && fijn.parentElement === som ? fijn : null);
          }
          var vt = VERZEND_KOSTEN;
          if (vz.lastChild.textContent !== vt) vz.lastChild.textContent = vt;
        } else if (vz) { vz.remove(); }
        if (fijn) setData(firstText(fijn), bbT('bb.js_bb_sparklayer_b2b.btw_zie_je_bij_het_afrekenen', 'Btw zie je bij het afrekenen.'));
        // Minimumorder: onder € 150 een regel boven de knop en de knop uit (klik geblokkeerd in bindLade).
        var mn = som.querySelector(':scope > .bb-minimum');
        if (btn && sub > 0 && sub < MIN_ORDER) {
          if (!mn) {
            mn = document.createElement('p');
            mn.className = 'bb-minimum';
            mn.id = 'bb-minimum';
            mn.setAttribute('aria-live', 'polite');
            som.appendChild(mn);
          }
          var rest = fmt(Math.round((MIN_ORDER - sub) * 100) / 100);
          var mh = bbT('bb.js_bb_sparklayer_b2b.bestellen_kan_vanaf', 'Bestellen kan vanaf € ') + MIN_ORDER + bbT('bb.js_bb_sparklayer_b2b.excl_btw_nog', ' excl. btw. Nog <b>') + rest + bbT('bb.js_bb_sparklayer_b2b.te_gaan', '</b> te gaan.');
          if (mn.innerHTML !== mh) mn.innerHTML = mh;
          if (btn.getAttribute('aria-disabled') !== 'true') btn.setAttribute('aria-disabled', 'true');
          if (btn.getAttribute('aria-describedby') !== 'bb-minimum') btn.setAttribute('aria-describedby', 'bb-minimum');
        } else {
          if (mn) mn.remove();
          if (btn && btn.hasAttribute('aria-disabled')) btn.removeAttribute('aria-disabled');
          if (btn && btn.getAttribute('aria-describedby') === 'bb-minimum') btn.removeAttribute('aria-describedby');
        }
      }
    }
  }

  // Avatar ("SS") en elke weg naar de account-modus → ons portaal.
  function bindLade(host) {
    if (!host || !host.shadowRoot || host.__bbLade) return;
    host.__bbLade = true;
    var sr = host.shadowRoot, runs = 0;
    sr.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('button') : null;
      if (b && b.getAttribute('data-bb') === 'avatar') {
        e.preventDefault(); e.stopImmediatePropagation();
        naarPortaal();
      }
      // Afrekenen onder het minimum: klik (ook Enter/spatie) komt niet bij SparkLayer aan.
      if (b && b.getAttribute('data-bb') === 'afrekenen' && b.getAttribute('aria-disabled') === 'true') {
        e.preventDefault(); e.stopImmediatePropagation();
      }
    }, true);
    // Direct in de observer-callback (microtask, vóór de volgende paint): geen flits van hun
    // opmaak en ook correct in een achtergrondtab (rAF pauzeert daar). applyLade schrijft alleen
    // bij verschil, dus de eigen mutaties doven na één extra ronde uit; runs is de noodrem.
    new MutationObserver(function () {
      if (runs++ > 20) return;
      if (runs === 1) setTimeout(function () { runs = 0; }, 0);
      applyLade(host);
    }).observe(sr, { childList: true, subtree: true, characterData: true });
    applyLade(host);
  }
  function scanLade() {
    var d = document.querySelector('spark-drawer');
    if (d && d.shadowRoot) bindLade(d);
    else if (d) setTimeout(scanLade, 50);
    if (!d) _ladeRedirecting = false;
  }
  try {
    // SparkLayer hangt spark-drawer bij elke open aan <body> en haalt hem bij sluiten weg.
    new MutationObserver(scanLade).observe(document.body || document.documentElement, { childList: true });
  } catch (e) {}
  scanLade();
  // Links die SparkLayer als account-knop ziet (/account…, data-spark-link=account) → portaal,
  // zonder eerst de lade te openen. Alleen ingelogd (bbSparkAuth zet theme.liquid in het auth-blok).
  document.addEventListener('click', function (e) {
    if (!window.bbSparkAuth || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var sel = null;
    try { sel = window.spark && window.spark.options && window.spark.options.accountButtonSelectors; } catch (x) {}
    if (!sel) return;
    try { if (!a.matches(sel)) return; } catch (x) { return; }
    if (/\/account\/logout/.test(a.getAttribute('href') || '')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    location.assign((window.BB_LP||'') + '/pages/mijn-account');
  }, true);

  function spark() { return window.spark; }
  // spark.isLoggedIn() geeft een Promise (altijd truthy) → daarop gaten was altijd waar,
  // ook voor gasten. Server-side vlag uit het auth-blok in theme.liquid is synchroon en
  // betrouwbaar; plus spark() zodat we niet vóór de SparkLayer-boot schilderen (23-09).
  function loggedIn() {
    return !!(window.bbSparkAuth && spark());
  }
  // Afspraak-SKU's van de ingelogde klant (autoritatief uit de Hub). De overlay
  // mag ALLEEN deze variants overschrijven; anders plet het de retail-staffels.
  // Sinds de base-retail-prijslijst heeft elke variant een SparkLayer-net, dus
  // SparkLayer alleen kan een echte afspraak niet van base-retail onderscheiden.
  var _agreedSkus = null; // Set; null = nog niet geladen
  // VE-gegevens uit dezelfde afspraken (lade-doosregel): {sku: {ps, perDoos}}; null = onbekend
  var _hubVe = null;
  function setHubVe(list) {
    _hubVe = {};
    (list || []).forEach(function (p) {
      if (!p || p.sku == null) return;
      _hubVe[String(p.sku)] = { ps: Number(p.pack_size) || 0, perDoos: !!p.per_doos && Number(p.stuks_per_doos) > 1 };
    });
  }
  // T16 (2026-07-03): SKU-set 1× per sessie cachen in sessionStorage (TTL 1u) —
  // scheelt een App-Proxy-fetch per paginaweergave op zoek/collectie/PDP.
  // Fout-pad wordt NIET gecachet.
  // Bugscan 27-09: de sleutel bevat nu de ingelogde klant (v3.<customerId>). Voorheen
  // zag klant B in dezelfde tab (uitloggen → inloggen) 1 uur lang de SKU-set van A.
  // Sleutels van een andere klant (en de oude v2) worden bij elk lezen gewist; zonder
  // klant-id geen cache. Een lege lijst (bv. kapot proxy-secret dat 200 + [] geeft)
  // houdt maar 2 min i.p.v. 1 uur.
  var SS_PREFIX = 'bbAgreedSkus.';
  var AgreeCache = {
    TTL_VOL: 3600000, TTL_LEEG: 120000,
    customerId: function (w) {
      try {
        var id = w.ShopifyAnalytics && w.ShopifyAnalytics.meta && w.ShopifyAnalytics.meta.page && w.ShopifyAnalytics.meta.page.customerId;
        if (!id && w.__st) id = w.__st.cid;
        return id ? String(id) : null;
      } catch (e) { return null; }
    },
    key: function (cid) { return cid ? SS_PREFIX + 'v3.' + cid : null; },
    // wist elke bbAgreedSkus.*-sleutel behalve die van deze klant
    purge: function (ss, keep) {
      var weg = [];
      for (var i = 0; i < ss.length; i++) { var k = ss.key(i); if (k && k.indexOf(SS_PREFIX) === 0 && k !== keep) weg.push(k); }
      weg.forEach(function (k) { ss.removeItem(k); });
    },
    geldig: function (c, now) {
      if (!c || !c.t || !Array.isArray(c.skus) || !Array.isArray(c.ve)) return false;
      return (now - c.t) < (c.skus.length ? AgreeCache.TTL_VOL : AgreeCache.TTL_LEEG);
    }
  };
  window.bbAgreeCache = AgreeCache;
  var _agreeInFlight = false; // in-flight-dedup (23-09): de fetch duurt tot ~19 s en de lus tikt elke 500 ms → was ~40 fetches per pagina; de volgende tik na afloop roept cb alsnog
  function loadAgreements(cb) {
    if (_agreedSkus) { cb(); return; }
    if (_agreeInFlight) return;
    var SS_KEY = AgreeCache.key(AgreeCache.customerId(window));
    try {
      AgreeCache.purge(sessionStorage, SS_KEY);
      var c = SS_KEY ? JSON.parse(sessionStorage.getItem(SS_KEY) || 'null') : null;
      if (AgreeCache.geldig(c, Date.now())) {
        _agreedSkus = new Set(c.skus.map(String));
        setHubVe(c.ve);
        cb(); return;
      }
    } catch (e) { /* privémodus e.d. — gewoon fetchen */ }
    _agreeInFlight = true;
    fetch('/apps/facturen/price-agreements', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }) // fout = onbekend (_hubVe blijft null), tabel-gedrag gelijk via catch
      .then(function (d) {
        var pa = (d && d.prijsafspraken) || [];
        _agreedSkus = new Set(pa.map(function (p) { return String(p.sku); }));
        var ve = pa.map(function (p) { return { sku: p.sku, pack_size: p.pack_size, per_doos: p.per_doos, stuks_per_doos: p.stuks_per_doos }; });
        setHubVe(ve);
        try {
          if (SS_KEY) sessionStorage.setItem(SS_KEY, JSON.stringify({ t: Date.now(), skus: Array.from(_agreedSkus), ve: ve }));
        } catch (e) { /* quota/privémodus — cache is optioneel */ }
        _agreeInFlight = false;
        cb();
      })
      .catch(function () { _agreeInFlight = false; if (!_agreedSkus) _agreedSkus = new Set(); cb(); });
  }
  // { variantId(externalId): nettoprijs } -- ALLEEN variants met een echte afspraak.
  function b2bByVariant() {
    var m = {};
    if (!_agreedSkus || !_agreedSkus.size) return m;
    try {
      spark().queryClient.getQueryCache().getAll().forEach(function (q) {
        var d = q.state && q.state.data;
        if (d && d.externalId && d.sku && _agreedSkus.has(String(d.sku)) &&
            d.price && typeof d.price.net === 'number') {
          m[String(d.externalId)] = d.price.net;
        }
      });
    } catch (e) {}
    return m;
  }
  function fmt(n) { return '€ ' + n.toFixed(2).replace('.', ','); }

  // --- PO-nummer custom checkout field (verschijnt op de shipping-stap) ---
  var PO_FIELD = {
    name: 'po number',
    translations: {
      nl: { title: 'PO-nummer', detail: 'Vul optioneel je inkoopordernummer in' },
      en: { title: 'PO number', detail: 'Optionally enter your purchase order number' }
    },
    attributes: { required: false, type: 'text', placeholder: 'Bijv. PO-12345', maxlength: 600 }
  };
  function ensurePoField() {
    var s = spark();
    if (!s || !s.options) return;
    var ce = s.options.checkoutCustomElements;
    if (!Array.isArray(ce)) { ce = s.options.checkoutCustomElements = []; }
    var has = ce.some(function (e) { return e && e.name === 'po number'; });
    if (!has) ce.push(PO_FIELD);
  }

  var obs = null;
  var painting = false;

  function paintTable() {
    if (painting || !loggedIn()) return;
    var prices = b2bByVariant();
    if (!Object.keys(prices).length) return;
    painting = true;
    try {
      document.querySelectorAll('tr[data-variant-id]').forEach(function (tr) {
        var vid = tr.getAttribute('data-variant-id');
        if (prices[vid] != null) {
          var v = fmt(prices[vid]);
          // T12 (2026-07-03): rij-highlight + "✓ jouw prijs"-chip voor afspraak-rijen.
          // Idempotent: classList.add is dat vanzelf; her-render wist rij → observer
          // paint 'm opnieuw. Chip alleen in de EERSTE prijskolom. Churn-guard leest
          // de prijs uit de eerste text-node (textContent zou de chip meetellen en
          // elke tick een rewrite triggeren). CSS: bb-product-varianttabel.liquid.
          tr.classList.add('bb-deal-row');
          tr.querySelectorAll('.bb-vpt-prijs').forEach(function (c, i) {
            var txt = (c.firstChild && c.firstChild.nodeType === 3) ? c.firstChild.textContent : c.textContent;
            if (txt.trim() !== v) c.textContent = v; // wist evt. chip mee; hieronder terug
            if (i === 0 && !c.querySelector('.bb-deal-chip')) {
              var chip = document.createElement('span');
              chip.className = 'bb-deal-chip';
              chip.textContent = bbT('bb.js_bb_sparklayer_b2b.jouw_prijs', '✓ jouw prijs');
              c.appendChild(chip);
            }
          });
        }
      });
    } finally { painting = false; }
  }

  // Observer op de tabel-container: na elke re-render opnieuw schilderen.
  function startObserver() {
    var host = document.querySelector('.bb-vpt-wrap') ||
               document.querySelector('[id^="bb-vpt-wrap"]');
    if (!host || obs) return;
    var t = null;
    obs = new MutationObserver(function () {
      if (painting) return;
      clearTimeout(t);
      t = setTimeout(paintTable, 60);
    });
    obs.observe(host, { childList: true, subtree: true });
  }

  // --- T16 (2026-07-03): "✓ Afspraakprijs"-badge op zoek/collectie-kaarten ---
  // card-product.liquid rendert data-skus op de kaart-root (alle variant-SKU's,
  // komma-gescheiden). Achter dezelfde loggedIn()+agreements-gate: gast ziet
  // niets, klant zonder afspraken ook niets. CSS wordt pas geïnjecteerd bij de
  // eerste badge (guests laden dus ook geen extra style). Idempotent per kaart;
  // draait mee in de bestaande interval-lus zodat facet-/AJAX-re-renders van het
  // grid de badge terugkrijgen.
  var CARD_BADGE_CSS =
    '.bb-deal-badge--card{position:absolute;top:8px;left:8px;z-index:2;' +
    'display:inline-flex;align-items:center;padding:4px 10px;border-radius:999px;' +
    'background:#e8f7ee;color:#137a3d;font-size:11px;font-weight:800;line-height:1.3;' +
    'box-shadow:0 1px 4px rgba(15,23,42,.08);pointer-events:none;}';
  function ensureCardBadgeStyle() {
    if (document.getElementById('bb-deal-card-style')) return;
    var s = document.createElement('style');
    s.id = 'bb-deal-card-style';
    s.textContent = CARD_BADGE_CSS;
    document.head.appendChild(s);
  }
  function markCards() {
    if (!_agreedSkus || !_agreedSkus.size) return;
    document.querySelectorAll('[data-skus]').forEach(function (card) {
      if (card.querySelector('.bb-deal-badge--card')) return; // idempotent
      var hit = (card.getAttribute('data-skus') || '').split(',').some(function (s) {
        return s && _agreedSkus.has(s.trim());
      });
      if (!hit) return;
      ensureCardBadgeStyle();
      var host = card.querySelector('.card__inner') || card; // .card__inner heeft .ratio → position:relative
      var b = document.createElement('div');
      b.className = 'bb-deal-badge bb-deal-badge--card';
      b.textContent = bbT('bb.js_bb_sparklayer_b2b.afspraakprijs', '✓ Afspraakprijs');
      host.appendChild(b);
    });
  }

  if (!window.bbSparkAuth) return; // gast/kijk-modus: geen afspraken-lus (23-09)
  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    if (loggedIn()) {
      ensurePoField();
      loadAgreements(function () {
        markCards();
        if (Object.keys(b2bByVariant()).length) {
          paintTable();
          startObserver();
        }
      });
    }
    if (tries > 400) clearInterval(iv);
  }, 500);
})();
